var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEconomicAssumption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66504 10.2625H4.66504V17.2625H6.66504V10.2625ZM12.665 10.2625H10.665V17.2625H12.665V10.2625ZM21.165 19.2625H2.16504V21.2625H21.165V19.2625ZM18.665 10.2625H16.665V17.2625H18.665V10.2625ZM11.665 3.52245L16.875 6.26245H6.45504L11.665 3.52245ZM11.665 1.26245L2.16504 6.26245V8.26245H21.165V6.26245L11.665 1.26245Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomicAssumption);
export default __webpack_public_path__ + "static/media/economic-assumption.e759b3e61bcb257073f5e5bbdf5f6eec.svg";
export { ForwardRef as ReactComponent };